/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module NetworkModule
 */

import {
    Component,
    Input,
} from '@angular/core';

import {
    ConfiguredNetwork,
} from 'ajs/modules/network/factories/configured-network.item.factory';

import './network-list-expander.component.less';

/**
 * @description
 *     Network Grid Expander Component.
 *
 *     Lists all the configured subnets and its static IP Pools and
 *     their types.
 *
 * @author Aravindh Nagarajan
 */
@Component({
    selector: 'network-list-expander',
    templateUrl: './network-list-expander.component.html',
})
export class NetworkListExpanderComponent {
    /**
     * ConfiguredNetwork instance.
     */
    @Input()
    public network: ConfiguredNetwork;

    /**
     * Callback to ngFor-track by
     */
    public trackbyIndex(index: number): number {
        return index;
    }
}
